// extracted by mini-css-extract-plugin
export default {"page":"ProvisioningPage_page__QrBe-"};